import React from 'react'
import Button from '../../../components/shared/button/Button'

const HeroSection = () => {
    return (
        <div className="max-lg:flex-col relative min-h-[1000px] heroBack flex items-center justify-between py-[64px] pb-[96px] max-lg:gap-[32px]  max-w-[1600px] w-full">
            <div className="flex flex-col max-lg:items-center items-start gap-[48px]  max-sm:pl-[0px] max-2xl:pl-[5.8vw] max-sm:gap-[24px]">
                <div className="flex flex-col items-start gap-[24px] max-lg:items-center max-sm:gap-[16px]">
                    <h1 className='font-bold text-[#101828] max-w-[584px] max-2xl:text-[48px] max-xl:text-[42px] max-lg:text-center text-[60px] max-md:text-[48px] max-sm:text-[28px]'>
                        Secure a Professional DJ for Your Event Through Certified DJs.
                    </h1>

                    <p className='text-[20px] text-[#475467] max-w-[480px] max-lg:text-center max-sm:text-[16px]'>
                        Experience Certified DJs: Book a Certified DJs for an Unforgettable Event.
                    </p>

                </div>
                <div className="flex items-start max-sm:flex-col max-sm:items-center gap-[16px]">
                    <div className="flex flex-col gap-[6px] max-w-[280px] max-sm:items-center max-sm:w-full ">
                        <input type="text" className='border-[1px] border-[#D0D5DD] max-sm:w-full rounded-[8px] px-[16px] py-[12px] outline-none text-[#667085] text-[16px] font-[400] ' placeholder='Enter your email' />
                        <span className='text-[#475467] max-sm:text-center'>
                            We care about your data in our <span className='cursor-pointer underline'>privacy policy.</span>
                        </span>
                    </div>
                    <Button children={'Join Waiting List'} />
                </div>
            </div>
            <img
                src="/images/consumerDJhome.png"
                alt=""
                className='max-w-[760px] max-2xl:max-w-[660px] max-xl:max-w-[560px] max-sm:max-w-full'
            />
        </div>
    )
}

export default HeroSection